import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from "@ngrx/store";
import { AppState } from "../../../../app.reducer";
import {
    GetMoveMyFolders,
    GetMoveFilesInMyFolder,
    MoveFileTo,
    GetMyFilesAndFolders,
    GetFilesInMyFolder,
    MoveToRootFolder,
    GetCitisFolders
} from '../_store/resources.actions'


@Component({
    selector: 'move-files',
    templateUrl: './move-files.component.html',
    styleUrls: ['./move-files.component.scss']
})
export class MoveFilesComponent implements OnInit {

    form: FormGroup;
    private stopper: Subject<void> = new Subject<void>();
    folderContents: any = [];
    fileID: string = '';
    fileFlag: boolean = false;
    directories = [];
    directoryID: any;
    oldFolderId: any;
    onFolderClick: boolean = false;
    onRootFolderClick: boolean = false;
    showRootFolderIcon: boolean = true;


    constructor(
        public dialogRef: MatDialogRef<MoveFilesComponent>,
        public action$: Actions,
        private store: Store<AppState>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.dialogRef.disableClose = true;
        this.fileID = data.fileId;
        this.fileFlag = data.Flag;
        this.oldFolderId = data.currentFolderId;
    }

    ngOnInit() {
    }

    getFolderContents(folder) {
        this.onFolderClick = true;
        this.onRootFolderClick = false;
        this.showRootFolderIcon = false;

        folder['dir_ID'] = (this.directories || []).length;
        this.directories.push(folder);

        this.store.dispatch(new GetMoveFilesInMyFolder(folder.folderId))
        this.store.select(state => state.resources.moveFilesInFolder).subscribe(response => {
            this.folderContents = response.subFoldersList || [];
            this.folderContents = (this.folderContents || []).filter((folder: any) => folder.folderId !== this.fileID);
        }, error => {
            console.log(error);
        });
    }

    gotoDirectory(folder) {
        this.onFolderClick = true;
        this.onRootFolderClick = false;
        this.showRootFolderIcon = false;
        this.directoryID = this.directories.filter(function (a) {
            return a.folderId == folder.folderId
        });
        let dirID = this.directoryID[0]['dir_ID']
        this.directories = this.directories.filter(function (a) {
            return a.dir_ID <= dirID
        });

        if (!folder.folderId) {
            this.onRootFolderClick = true
            if(folder.name == 'CITIIS'){
            this.store.dispatch(new GetCitisFolders({}));
            }else{
            this.store.dispatch(new GetMoveMyFolders());
            }
        }
        else {
            this.store.dispatch(new GetMoveFilesInMyFolder(folder.folderId))
            this.store.select(state => state.resources.moveFilesInFolder).subscribe(response => {
                this.folderContents = response.subFoldersList
            }, error => {
                console.log(error);
            });
        }

    }

    clearDirectoryList() {
        this.onFolderClick = false;
        this.onRootFolderClick = false;
        this.showRootFolderIcon = true;
        this.directories = []
        this.folderContents = []
    }

    moveFile() {
        if (this.onRootFolderClick) {
            const payload = {}

            if (this.fileFlag == false) {
                payload['subFolderId'] = this.fileID;
            } else {
                payload['docId'] = this.fileID;
            }

            this.store.dispatch(new MoveToRootFolder(this.oldFolderId, payload));
        }
        else {
            let folderId;
            if ((this.directories || []).length > 1) {
                folderId = this.directories[this.directories.length - 1].folderId;
            } else if ((this.directories || []).length === 1) {
                folderId = this.directories[0].folderId;
            } else {
                folderId = '';
            }
            let docPayload = {};
            // if fileFlag = true (moving of document) and if fileFlag = false (moving of folder)
            if (this.fileFlag == false) {
                docPayload['subFolderId'] = this.fileID;
            } else {
                docPayload['docId'] = this.fileID;
            }
            if (this.oldFolderId) {
                docPayload['oldFolderId'] = this.oldFolderId;
            }

            this.store.dispatch(new MoveFileTo(folderId, docPayload));
        }

        this.store.select(state => state.resources.files).subscribe(res => {
            if (this.oldFolderId) {
                this.store.dispatch(new GetFilesInMyFolder(this.oldFolderId, { page: 1, limit: 30 }));
            } else {
                this.store.dispatch(new GetMyFilesAndFolders({ page: 1, limit: 30 }));
            }
            this.dialogRef.close();
        },
            err => {
                console.log(err);
            });
    }

    moveToRootFolder() {
        this.onFolderClick = true;
        this.onRootFolderClick = true;
        this.showRootFolderIcon = false;

        this.directories.push({ name: 'Folders', dir_ID: 0 });

        this.store.dispatch(new GetMoveMyFolders());
        this.store.select(state => state.resources.myMoveFolders).pipe(takeUntil(this.stopper)).subscribe(response => {
            this.folderContents = response || [];
            if (!this.fileFlag) {
                this.folderContents = this.folderContents.filter(folder => {
                    return folder.folderId !== this.fileID;
                });
            }
        },
            error => {
                console.log(error)
            });
    }

    moveToCitiisRootFolder(){
        this.onFolderClick = true;
        this.onRootFolderClick = true;
        this.showRootFolderIcon = false;

        this.directories.push({ name: 'CITIIS', dir_ID: 0 });

        this.store.dispatch(new GetCitisFolders({}));
        this.store.select(state => state.resources.citisFolders).pipe(takeUntil(this.stopper)).subscribe(response => {
            console.log(response);
            this.folderContents = response.folders || [];
            console.log(this.folderContents);

            // if (!this.fileFlag) {
                this.folderContents = this.folderContents.filter(folder => {
                    return folder.folderId !== this.fileID;
                });
            // }
        },
            error => {
                console.log(error)
            });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    ngOnDestroy() {
        this.stopper.next();
        this.stopper.complete();
    }
}
